export default class Date {
	constructor({ id, date, event } = {}) {
		this.id = id;
		this.date = date;
		this.event = event;
	}

	static buildFromJSON(json) {
		return new Date({
			id: json.id,
			date: json.date,
			event: json.event
		});
	}

	toJSON() {
		return {
			id: this.id,
			date: this.date,
			event: this.event
		};
	}

	getId() {
		return this.id;
	}

	getDate() {
		return this.date;
	}

	getEvent() {
		return this.event;
	}
}
